import { makeStyles } from '@mui/styles';

export const useBarCharStyles = makeStyles({
  wrapper: {
    width: '100%',
    position: 'relative'
  },
  noData: {
    position: 'absolute',
    fontSize: '16px',
    fontWeight: 600,
    top: '50%',
    left: '50%',
    marginTop: '-20px',
    marginLeft: '-62px',
    backgroundColor: 'white',
    padding: '8px 24px',
    borderRadius: '10%',
    boxShadow: '0 0 8px 0 rgb(82 63 105 / 15%)'
  },
  loading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-50px',
    marginLeft: '-50px'
  }
});
